import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'

import NotFoundView from '@/components/error/404.vue'
import Account from '@/components/view/allbots/Account'
import LivechatView from '@/components/view/livechat/LivechatView'
import Home from '@/components/view/home/Home'
import config from '../config'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/autofblogin',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        name: 'AutofbLogin',
        component: function(resolve) {
          require(['@/components/login/AutofbLogin.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/autolinelogin',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        name: 'AutolineLogin',
        component: function(resolve) {
          require(['@/components/login/AutolineLogin.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connectline',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        name: 'ConnectLine',
        component: function(resolve) {
          require(['@/components/login/ConnectLine.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/linenotify',
    beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function(resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/callback',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: 'event-conversion',
        name: 'EventConversionCallback',
        component: function(resolve) {
          require(['@/components/callback/EventConversion.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'home'
      },
      {
        path: 'login',
        name: 'login',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'nigol',
        // name: 'nigol',
        redirect: 'login'
      },
      {
        path: 'meta',
        name: 'meta',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'iconkaset',
        name: 'iconkaset',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: function(resolve) {
          require(['@/components/login/Chat2Pay.vue'], resolve)
        },
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'home',
        name: 'home',
        component: Home,
        beforeEnter: guardRoute,
        meta: {
          title: 'Home'
        }
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  if (config.maintenance && !to.path.endsWith('/maintenance')) {
    return next(`/${store.getters.currentLang}/maintenance`)
  }
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (store.state.privilege.role === 'admin') {
    if (
      to.name !== 'allbots' &&
      to.name !== 'template' &&
      to.name !== 'home' &&
      to.name !== 'Upgrade'
    ) {
      next({
        path: '*'
      })
    }
  }

  var query = { ...to.query }
  query.redirect = to.fullPath

  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/login',
      query: query
    })
  } else {
    window.onload = function() {
      if (store.state.isFacebook) {
        if (store.state.selectedBot) {
          store.dispatch('updateBotDetail').then(
            function(response) {
              // checkTokenStatus(next)
              next()
            },
            function(e) {
              next({
                path: '/' + store.getters.currentLang + '/login',
                query: query
              })
            }
          )
        }
        next()
      } else {
        if (store.state.selectedBot) {
          store.dispatch('updateBotDetail').then(
            function(response) {
              // checkTokenStatus(next)
              next()
            },
            function(e) {
              next({
                path: '/' + store.getters.currentLang + '/login',
                query: query
              })
            }
          )
        }

        next()
      }
    }
    next()
  }
}


// WEBPACK FOOTER //
// ./src/router/index.js